/**
 * マッピングで選択可能な項目定義
 */
export type OrderTemplateMappingField = {
  /** 保存時に利用するフィールドキー */
  fieldKey: string;
  /** 画面表示用のラベル */
  label: string;
};

/**
 * 発注テンプレートのマッピング項目一覧
 */
export const ORDER_TEMPLATE_MAPPING_FIELDS: OrderTemplateMappingField[] = [
  { fieldKey: 'businessName', label: '商品名' },
  { fieldKey: 'businessNumber', label: '商品コード' },
  { fieldKey: 'orderAmount', label: '数量' },
  { fieldKey: 'desiredDeliveryDate', label: '希望納期' },
  { fieldKey: 'orderIssuedNumber', label: '発注管理番号' },
  { fieldKey: 'orderNumber', label: '発注書番号' },
  { fieldKey: 'createdOrderDate', label: '発注作成日' },
  { fieldKey: 'supplierName', label: '仕入先名' },
  { fieldKey: 'supplierNumber', label: '仕入先コード' },
  { fieldKey: 'package', label: '容量' },
  { fieldKey: 'warehouse', label: '置場名' },
  { fieldKey: 'warehouseNumber', label: '置場コード' },
  { fieldKey: 'manufacturer', label: '製造社' },
  { fieldKey: 'orderGroupName', label: 'グループ名' },
  { fieldKey: 'invoiceNumber', label: 'インボイス番号' },
  { fieldKey: 'destinationName', label: '仕向地' },
  { fieldKey: 'orderNote', label: 'メモ' },
  { fieldKey: 'userCustomParameters', label: 'ユーザー固有番号' },
];
